export const SET = 'escape-plan/SET';
export const RESET = 'escape-plan/RESET';
export const UPDATE = 'escape-plan/UPDATE';
export const REMOVE = 'escape-plan/DELETE';
export const RESET_REDUX = 'escape-plan/RESET_REDUX';
